import { render, staticRenderFns } from "./SupportView.vue?vue&type=template&id=48569e7d&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"
import style0 from "./SupportView.vue?vue&type=style&index=0&id=48569e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48569e7d",
  null
  
)

export default component.exports